<template>
  <v-app id="home">
    <v-app-bar
      app
      color="white"
      dense
      fixed
    >
      <!-- <div class="d-flex align-center">
        abc
      </div> -->
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = true"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-btn to="/" v-scroll-to="'#home'" text color="secondary--text" class="hidden-sm-and-down" active-class="secondary--text">
        <v-icon color="secondary">mdi-home</v-icon>
        <span class="ml-2">Home</span>
      </v-btn>
      <v-btn v-for="(item,i) in menuItems" :key="i" to="/" v-scroll-to="item.link" text color="secondary--text" class="hidden-sm-and-down" active-class="secondary--text">
        <v-icon color="secondary">{{ item.icon }}</v-icon>
        <span class="ml-2">{{ item.text }}</span>
      </v-btn>
      
      <v-spacer></v-spacer>

    </v-app-bar>

    <v-navigation-drawer
      app
      temporary
      v-model="drawer"
    >
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="secondary--text"
        >
          <v-list-item @click="drawer = false" link to="/" v-scroll-to="'#home'">
            <v-list-item-icon><v-icon color="secondary">mdi-home</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="(item,i) in menuItems" :key="i" @click="drawer = false" link to="/" v-scroll-to="item.link">
            <v-list-item-icon><v-icon color="secondary">{{ item.icon }}</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <HelloWorld/>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    drawer: false,
    menuItems: [
      {
        'text': 'Termin',
        'link': '#appointment',
        'icon': 'mdi-phone'
      },
      {
        'text': 'Öffnungszeiten',
        'link': '#openinghour',
        'icon': 'mdi-calendar-clock'
      },
      {
        'text': 'Preise',
        'link': '#price',
        'icon': 'mdi-text-box-outline'
      },
      {
        'text': 'Produkte',
        'link': '#product',
        'icon': 'mdi-spray' // mdi-leaf
      },
    ]
  }),
};
</script>
